module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_VAlueBox.7d44001b.png";